import React, { Component } from 'react';
import CustomInputField from '../../components/CustomInput/CustomInputField';
import CustomFileUpload from '../../components/CustomInput/CustomFileUpload';
import MobCamera from '../../components/MobUpaod/MobCamera';
import { FileUploadHandlers } from '../KYCGuider/FileSpec';
import { UploadFile } from '../KYCGuider/FileUpload';
import { CloseEvent } from '../KYCGuider/CloseEvent';
import { OCREvent } from '../KYCGuider/OCREvent';
import Checked from '../../images/icons/checkbox_ok.svg';
import Onload from '../../images/icons/loading2.svg';
import NotOK from '../../images/icons/verification_failed.svg';
import NotVerified from '../../images/icons/not_verified.svg';
import window from 'window-or-global';
import { getUserId } from '../../common/utils/cookie-utils';
import CommonInput from '../../components/Dashboard-res/CommonComponent/CommonInput';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import CommonDatePicker, {
  currentYear
} from '../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import get from 'lodash/get';
import RadioButton from '../Dashboard-res/CommonComponent/RadioButton';
import { UpdateKYCstepAPI } from '../../common/constants/api';
import FileUpload from '../../images/icons/file_upload.svg';

class VoterID extends Component {
  constructor(props) {
    super(props);
    this.state = {
      voter_id: '',
      voter_id_editable: true,
      name: '',
      name_editable: true,
      dob: '',
      dob_editable: true,
      age: '',
      age_editable: true,
      rel: '',
      rel_editable: true,
      address: '',
      address_editable: true,
      male: true,
      female: '',
      gender_editable: true,
      file_id: '',
      submit: false,
      date: '',
      month: '',
      year: '',
      FileUploadCount: 0
    };
    this.handleChange = this.handleChange.bind(this);
    this.setChanged = this.setChanged.bind(this);
  }

  setChanged = response => {
    let res = response.kycEntries,
      dob;
    if (res.dob) {
      dob = res.dob.value.toString();
      dob = dob.split('/');

      if (res.gender.value === 'MALE') {
        this.setState({
          male: true,
          gender_editable: res.gender.editable,
          female: false
        });
      } else if (res.gender.value === 'FEMALE') {
        this.setState({
          female: true,
          gender_editable: res.gender.editable,
          male: false
        });
      }
    }
    let data = [
      { key: 'voter_id', value: 'voterId', editable: '' },
      { key: 'name', value: 'name', editable: '' },
      { key: 'dob', value: 'dob', editable: '' },
      { key: 'age', value: 'age', editable: '' },
      { key: 'rel', value: 'relativeName', editable: '' },
      { key: 'address', value: 'address', efitable: '' }
    ];
    for (let m = 0; m < data.length; m++) {
      try {
        let value = res[data[m].value].value;
        if (value) {
          if (data[m].key === 'dob') {
            const Months = [
              'January',
              'February',
              'March',
              'April',
              'May',
              'June',
              'July',
              'August',
              'September',
              'October',
              'November',
              'December'
            ];
            this.setState({
              date: String(+dob[0]),
              month: Months[parseInt(dob[1] - 1)],
              year: dob[2]
            });
            this.setState({ dob_editable: res[data[m].value].editable });
          }

          this.setState({
            [data[m].key]: value,
            [data[m].key + '_editable']: res[data[m].value].editable
          });
        }
      } catch (e) {
        this.setState({ [data[m].key + '_editable']: true });
        console.log({ 'error in setChanged': e });
      }
    }
  };

  file_checker_not_ok = (id, error_message) => {
    if (window.innerWidth > 768) {
      let doc_error = document.getElementById(id + '_error');
      doc_error.style.display = 'block';
      doc_error.innerHTML = error_message;

      //change karne
      setTimeout(() => {
        document.getElementById(id + '_image').src = FileUpload;
      }, 500);
    }
  };

  file_checker_ok = res => {
    let data = {
      partnerId: parseInt(getUserId()),
      kycStepId: 3,
      docTypeId: 3,
      fileType: 'png'
    };

    UploadFile(res, data, this.Upload_ok, this.Upload_not_ok);
  };

  Upload_ok = res => {
    UpdateKYCstepAPI({
      url: res.url,
      requestId: res.requestId
    }).catch(err => console.log(err));

    if (window.innerWidth > 768) {
      try {
        document.getElementById(this.state.file_id + '_image').src = Checked;
        document.getElementById(this.state.file_id + '_image').style.width =
          '28px';
      } catch {}
    }

    try {
      let voterId = ['voter_id_f', 'voter_id_b'];
      CloseEvent(voterId, this.close_event_ok, this.close_event_not_ok);
    } catch (e) {
      console.log({ close: e });
    }
    try {
      let data = { partnerId: parseInt(getUserId()), fileName: res.fileName };
      OCREvent(data, this.ocr_ok, this.ocr_not_ok);
    } catch (e) {
      console.log({ ocr: e });
    }
  };

  Upload_not_ok = res => {
    if (window.innerWidth > 768) {
      document.getElementById(this.state.file_id + '_image').src = NotOK;
      document.getElementById(this.state.file_id + '_image').style.width =
        '28px';
    }
  };

  ocr_ok = res => {
    this.setState({ FileUploadCount: this.state.FileUploadCount + 1 });
    if (this.state.FileUploadCount === 2) this.props.setCanProceed(true);
    this.setChanged(res);
  };

  ocr_not_ok = () => {};

  close_event_ok = () => {
    this.setState({ submit: true });
    if (window.innerWidth > 768) {
      document.getElementById('web_address_image').src = NotVerified;
      document.getElementById('web_address_message').innerHTML =
        'Verification is Pending';
      document.getElementById('web_address_message').style.color = 'orange';
    } else {
      let a = document.getElementById('doc_container');
      a.style.backgroundColor = 'white';
      a.style.height = '100%';
      a.style.position = 'absolute';
      a.style.opacity = '1';
      document.getElementById('upload_back').style.display = 'none';
    }
  };

  close_event_not_ok = () => {};

  FileUploadHandler = id => {
    // Hide the visibility of the upload docs area
    if (window.innerWidth > 768) {
      this.setState({ file_id: id });

      document.getElementById(id + '_area').style.display = 'none';
      document.getElementById(id + '_image').src = Onload;
      document.getElementById(id + '_image').style.width = '28px';
    }
    try {
      // Upload the file
      FileUploadHandlers(id, this.file_checker_ok, this.file_checker_not_ok);
    } catch (e) {
      console.log({ 'File Checker ': e });
    }
  };

  handleChange = event => {
    let id = event.target.name + '_editable';
    if (
      (event.target.name === 'male' || event.target.name === 'female') &&
      this.state.gender_editable
    ) {
      if (event.target.name === 'male') {
        this.setState({ male: true, female: false });
      } else if (event.target.name === 'female') {
        this.setState({ female: true, male: false });
      }
    } else if (this.state[[id]]) {
      this.setState({ [event.target.name]: event.target.value });
    }
  };

  render() {
    const ValidationSchema = Yup.object().shape({
      voter_id: Yup.string()
        .min(1, 'Too Short Name!')
        .max(70, 'Too Long Name!')
        .required('Required'),
      name: Yup.string()
        // .matches(/([a-z 6-9]\d{10})/, 'PAN Number should be 10 digit ')
        .min(1, 'Too Short Name!')
        .max(70, 'Too Long Name!')
        .required('Required'),

      age: Yup.string().required('Required'),
      rel: Yup.string().required('Required'),
      address: Yup.string()
        .min(1, 'Too Short Name!')
        .required('Required'),
      date: Yup.object().shape({
        value: Yup.string().required('Required')
      }),
      month: Yup.object().shape({
        value: Yup.string().required('Required')
      }),
      year: Yup.object().shape({
        value: Yup.string().required('Required')
      })
    });

    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          //get takes 3 agrument 1st obj, 2nd keypath
          voter_id: this.state.voter_id,
          name: this.state.name,
          age: this.state.age,
          rel: this.state.rel,
          address: this.state.address,
          date: {
            value: this.state.dob_editable ? '' : this.state.date,
            label: 'Date'
          },
          month: {
            value: this.state.dob_editable ? '' : this.state.month,
            label: 'Month'
          },
          year: {
            value: this.state.dob_editable
              ? String(currentYear - 18)
              : this.state.year,
            label: String(currentYear - 18)
          }
          //   male:this.state.male,
          //   female:this.state.female
        }}
        validationSchema={ValidationSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          // this.props.componentHandler(6);
          // PANSubmit({s
          //     name: {
          //         name: values.name,
          //         // lastName: "lastName",
          //     },
          //     pan_no: values.pan_no,
          //     father_name: values.father_name,
          //     // dob: new Date(
          //     //     `${values.year.value}-${values.month.value}-${values.date.value}`
          //     // )
          // })
        }}
      >
        {({
          errors,
          touched,
          handleChange,
          values,
          setFieldValue,
          setFieldTouched,
          handleSubmit,
          handleBlur
        }) => {
          return (
            <Form onSubmit={handleSubmit} className="w-full">
              <div
                className=" mt-3 hidden w-full px-2 block md:block  bg-white   rounded-lg md:mx-auto  pt-8"
                id="doc_list_container"
              >
                <div className="w-full md:flex md:px-4 px-1 md:w-2/4 block">
                  <div className="w-full flex md:hidden  text-center mx-auto font-roboto font-bold">
                    <p
                      className="text-black-600 text-basic "
                      id="pan_card_name"
                    >
                      {' '}
                    </p>
                    <img
                      className="w-4/12 md:w-3/4 mt-6 mb-8 mx-auto"
                      id="card_photo"
                      src=""
                    />
                    <img
                      className="w-4/12 md:w-3/4 mt-6 mb-8 mx-auto"
                      id="card_photo_back"
                      src=""
                    />

                    <iframe
                      className="md:w-3/4 mt-6 mb-8 mx-auto hidden"
                      id="card_photo_iframe"
                      src=""
                    ></iframe>
                  </div>
                </div>
                <div className="w-full flex" id="doc_value_container">
                  <div
                    className="w-full md:flex  hidden md:block bg-grey-0 px-4  md:px-0 md:bg-white rounded-lg  mx-auto "
                    id="upload_container"
                  >
                    <div className="w-1/2">
                      <CustomFileUpload
                        val={{
                          id: 'voter_id_f',
                          file_caption: 'upload front page'
                        }}
                        file_handler={this.FileUploadHandler}
                      />
                    </div>
                    <div className="w-1/2">
                      <CustomFileUpload
                        val={{
                          id: 'voter_id_b',
                          file_caption: 'upload back page'
                        }}
                        file_handler={this.FileUploadHandler}
                      />
                    </div>
                  </div>
                  <div
                    className="w-full md:w-2/4 md:hidden  visible  mx-auto md:block pt-3 text-left"
                    id="doc_values_division"
                  >
                    <div className="mt-10">
                      <CommonInput
                        name="voter_id"
                        disabled={!this.state.voter_id_editable}
                        onChange={this.handleChange}
                        onBlur={handleBlur}
                        value={this.state.voter_id}
                        stylesContainer={{
                          height: '52px',
                          maxWidth: '100%'
                        }}
                        legendName="Voter ID Number"
                        error={touched.voter_id && errors.voter_id}
                        errorMsg={errors.voter_id}
                        touched={touched.voter_id}
                      />
                    </div>
                    <div className="mt-10">
                      <CommonInput
                        name="name"
                        disabled={!this.state.name_editable}
                        onChange={this.handleChange}
                        onBlur={handleBlur}
                        value={this.state.name}
                        stylesContainer={{
                          height: '52px',
                          maxWidth: '100%'
                        }}
                        legendName="Name"
                        error={touched.name && errors.name}
                        errorMsg={errors.name}
                        touched={touched.name}
                      />
                    </div>
                    <div className="mt-10">
                      <CommonInput
                        name="age"
                        disabled={!this.state.age_editable}
                        onChange={this.handleChange}
                        onBlur={handleBlur}
                        value={this.state.age}
                        stylesContainer={{
                          height: '52px',
                          maxWidth: '100%'
                        }}
                        legendName="Age"
                        error={touched.age && errors.age}
                        errorMsg={errors.age}
                        touched={touched.age}
                      />
                    </div>
                    <div className="mt-10">
                      <CommonInput
                        name="rel"
                        disabled={!this.state.rel_editable}
                        onChange={this.handleChange}
                        onBlur={handleBlur}
                        value={this.state.rel}
                        stylesContainer={{
                          height: '52px',
                          maxWidth: '100%'
                        }}
                        legendName="Relation"
                        error={touched.rel && errors.rel}
                        errorMsg={errors.rel}
                        touched={touched.rel}
                      />
                    </div>
                    <div className="mt-10">
                      <CommonInput
                        name="address"
                        disabled={!this.state.address_editable}
                        onChange={this.handleChange}
                        onBlur={handleBlur}
                        value={this.state.address}
                        stylesContainer={{
                          height: '52px',
                          maxWidth: '100%'
                        }}
                        legendName="Adress"
                        error={touched.address && errors.address}
                        errorMsg={errors.address}
                        touched={touched.address}
                      />
                    </div>
                    <div className="w-full mt-10">
                      <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                        DOB
                      </div>
                      <CommonDatePicker
                        onChangeMonth={(value, isValidDate) => {
                          {
                            this.state.dob_editable
                              ? setFieldValue('month', value, true)
                              : null;
                          }
                          setFieldTouched('month', true, false);
                          if (!isValidDate) {
                            setFieldValue(
                              'date',
                              {
                                value: '',
                                label: 'Date'
                              },
                              true
                            );
                          }
                        }}
                        onChangeYear={(value, isValidDate) => {
                          {
                            this.state.dob_editable
                              ? setFieldValue('year', value, true)
                              : null;
                          }
                          setFieldTouched('year', true, false);

                          if (!isValidDate) {
                            setFieldValue(
                              'date',
                              {
                                value: '',
                                label: 'Date'
                              },
                              true
                            );
                          }
                        }}
                        onChangeDate={value => {
                          {
                            this.state.dob_editable
                              ? setFieldValue('date', value, true)
                              : null;
                          }
                          setFieldTouched('date', true, false);
                        }}
                        valueMonth={
                          this.state.dob_editable
                            ? values.month
                            : {
                                value: String(this.state.month),
                                label: String(this.state.month)
                              }
                        }
                        valueYear={
                          this.state.dob_editable
                            ? values.year
                            : {
                                value: String(this.state.year),
                                label: String(this.state.year)
                              }
                        }
                        valueDate={
                          this.state.dob_editable
                            ? values.date
                            : {
                                value: String(this.state.date),
                                label: String(this.state.date)
                              }
                        }
                        errorYear={
                          touched.year && get(errors, 'year.value', false)
                        }
                        touchedYear={touched.year}
                        onBlurYear={() => {
                          setFieldTouched('year', true, true);
                        }}
                        errorMonth={
                          touched.month && get(errors, 'month.value', false)
                        }
                        touchedMonth={touched.month}
                        onBlurMonth={() => {
                          setFieldTouched('month', true, true);
                        }}
                        // errors.date.value
                        errorDate={
                          touched.date && get(errors, 'date.value', false)
                        }
                        touchedDate={touched.date}
                        onBlurDate={() => {
                          setFieldTouched('date', true, true);
                        }}
                        //  errorMsg= "DOB is not selected"
                        type="dob"
                      />
                    </div>
                    <div className="w-full text-left mt-8 mr-auto ml-2">
                      <div className="flex ">
                        <div className="flex items-center">
                          <RadioButton
                            name="male"
                            value="male"
                            checked={this.state.male === true}
                            onChange={this.handleChange}
                            onBlur={handleBlur}
                          />
                          <label
                            htmlFor="Owned"
                            className="text-black-400 text-sm m-2"
                          >
                            Male
                          </label>
                        </div>
                        <div className="flex items-center">
                          <RadioButton
                            name="female"
                            value="female"
                            checked={this.state.female === true}
                            onChange={this.handleChange}
                            onBlur={handleBlur}
                          />
                          <label
                            htmlFor="Owned"
                            className="text-black-400 text-sm m-2"
                          >
                            Female
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <MobCamera
                input_component="voter_id_f_m"
                main_id="upload_front"
                onchange={this.FileUploadHandler}
                caption=" FRONT SIDE ->Upload  From "
              />
              <MobCamera
                input_component="voter_id_b_m"
                main_id="upload_back"
                onchange={this.FileUploadHandler}
                caption="BACK SIDE ->Upload From "
              />

              {this.state.submit ? (
                <button
                  className=" submitButton w-56
                lg:w-80 hidden "
                  type="submit"
                  id="submit"
                  style={{ display: 'none' }}
                >
                  CONTINUE
                </button>
              ) : null}
            </Form>
          );
        }}
      </Formik>
    );
  }
}
export default VoterID;
